export default __webpack_public_path__ + "static/media/fiorino-branca.78d1e735.png";